import { useEffect, useState } from 'react';

/**
 * Mirrors the `max-width: 768px` breakpoint every mobile rule in index.css uses.
 * Only for the cases CSS cannot express — chiefly rendering an overlay into a
 * portal so it escapes the stacking context of the bar it was opened from.
 */
const MOBILE_QUERY = '(max-width: 768px)';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const update = (event) => setIsMobile(event.matches);

    setIsMobile(media.matches);
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);

  return isMobile;
};

export default useIsMobile;
